import nav from './nav'
import home from './home'
import store from './store'
import business from './business'
import news from './news'
import games from './games'
import about from './about'
import notice from './notice'
export default {...nav, ...home, ...store, ...business, ...news, ...games, ...about , ...notice};


// WEBPACK FOOTER //
// ./src/lang/all.js